<div class="trial-warning-main d-flex" *ngIf="showWarning">
  <div class="trial-warning-icon-div d-grid align-items-start justify-content-center">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="rgb(0, 190, 255)">
      <path d="M120-200h120v-120H120v120Zm0-200h120v-120H120v120Zm0-200h120v-120H120v120Zm200 400h120v-120H320v120Zm0-200h120v-120H320v120Zm0-200h120v-120H320v120Zm200 400h120v-120H520v120Zm0-200h120v-120H520v120Zm0-200h120v-120H520v120Z"/>
    </svg>
  </div>
  <div class="trial-warning-text-div align-items-center justify-content-start">
    <div class="trial-warning-message">
      <span>{{ 'GENERAL.TRIAL_LICENSE_WARNING' | translate }}</span>
    </div>
  </div>
</div>


